import { ReactComponent as ImgPhone } from "../../assets/images/img-phone.svg"
import LocalizedLogo from "./LocalizedLogo"
import { ReactComponent as ImgBgTopBlob} from "../../assets/images/layout/bg-kv-blob.svg"

export default ({ text, link, onClick,isMember=false }) => {
  return (
    <>
      <div>
        { <LocalizedLogo className="logo" /> }
      </div>
      <ImgPhone className="img-phone" />
      {
        sessionStorage?.getItem("loadTheme")==='mint' && isMember===false?
        (<></>):
        ( <a style={{ cursor: 'pointer' }} onClick={onClick} className="kv-link-btn" href={link}>{text}</a>)
        
      }
    
      <ImgBgTopBlob className="img-kv-bg" />
    </>)
}